import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DistributionArea } from 'planning-portal-library/src/lib/core/domain';
import { injectEnvironment } from 'planning-portal-library/src/lib/core/environments/environment.token';
import { DistributionAreaRepository } from 'planning-portal-library/src/lib/core/repositories';
import { catchError, map, mergeMap, Observable, reduce } from 'rxjs';
import { BaseResponse } from '../../../shared/base.response';
import { DistributionAreaApiUrls } from './distribution-area-api-urls';
import { DistributionAreaWebRepositoryMapper } from './entities/distribution-area-web-repository-mapper';

@Injectable({ providedIn: 'root' })
export class DistributionAreaWebRepository extends DistributionAreaRepository {
  private readonly distributionAreaWebRepositoryMapper =
    new DistributionAreaWebRepositoryMapper();
  private readonly environment = injectEnvironment();

  constructor(private readonly http: HttpClient) {
    super();
  }

  getDistributionAreas(
    distributionLaneId: string
  ): Observable<DistributionArea[]> {
    return this.http
      .get<BaseResponse<DistributionArea[]>>(
        `${this.environment.url}${DistributionAreaApiUrls.GetDistributionAreas}?distributionLaneId=${distributionLaneId}`
      )
      .pipe(
        mergeMap(
          (response: BaseResponse<DistributionArea[]>) => response.result!
        ),
        catchError((error) => {
          throw error;
        })
      )
      .pipe(map(this.distributionAreaWebRepositoryMapper.mapFrom))
      .pipe(
        reduce(
          (items: DistributionArea[], item: DistributionArea) => [
            ...items,
            item,
          ],
          []
        )
      );
  }
}
